import Call from '../../Call.v2';

const Percentage = {
    get() {
        return Call(`filler/percentage`);
    },

    save(percentage) {
        return Call(`filler/percentage`, 'POST', { percentage });
    },
};

export default Percentage;


// WEBPACK FOOTER //
// ./src/services/API/components/Filler/Percentage.js